import React from "react"
import { Link } from 'react-router-dom'

export default function EmptyCart() {

    return (
        <>
            <div className="viewEmptyCart">
                <div className="cartEmpty">
                    <div className="carritoVacio"></div>
                    <h1>¡Carrito vacío!</h1>
                    <p>Aún no tienes productos en tu carrito de compras.</p>
                    <Link to="/" className="btn rojo">Seguir navegando</Link>
                </div>
            </div>
        </>
    )
}